module.exports = __webpack_public_path__ + "static/img/009.19bea6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/009.jpg
// module id = Y46M
// module chunks = 1